import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityImportAnnotations } from '../../projectDetailsActivities.models';

export const ImportAnnotationsActivity = ({ values }: IProjectActivity<IProjectActivityImportAnnotations>): ReactElement => {
  const { t } = useTranslator();
  return <span>{t('activity_description_Import_Annotations', { ...values })}</span>;
};
